// import { Directive, HostListener, ElementRef } from '@angular/core';

// @Directive({
//   selector: '[remove-spaces-number]'
// })
// export class RemoveSpacesNumberDirective {

//   constructor(private el: ElementRef) {}

//   // Evitar caracteres no numéricos con keypress
//   @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
//     const charCode = event.key.charCodeAt(0);

//     // Solo permitir números (charCode entre 48 y 57)
//     if (charCode < 48 || charCode > 57) {
//       event.preventDefault();
//     }
//   }

//   // Eliminar espacios y caracteres no numéricos en el evento input
//   @HostListener('input', ['$event']) onInputChange(event: Event) {
//     const input = this.el.nativeElement;
    
//     // Actualiza el valor eliminando los espacios y cualquier carácter no numérico
//     const cleanValue = input.value.replace(/\s+/g, '').replace(/[^0-9]/g, '');

//     // Solo actualiza si el valor es diferente, evitando ciclos infinitos
//     if (input.value !== cleanValue) {
//       input.value = cleanValue;
//     }
//   }

// }
import { Directive, HostListener, ElementRef, Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[remove-spaces-number]',
})
export class RemoveSpacesNumberDirective {

  @Input() formControlName: string = ''; // Inicializa la propiedad con un valor por defecto

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  // Evitar caracteres no numéricos con keypress
  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);

    // Solo permitir números (charCode entre 48 y 57)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  // Eliminar espacios y caracteres no numéricos en el evento input
  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = this.el.nativeElement;
    
    // Actualiza el valor eliminando los espacios y cualquier carácter no numérico
    const cleanValue = input.value.replace(/\s+/g, '').replace(/[^0-9]/g, '');

    // Solo actualiza si el valor es diferente, evitando ciclos infinitos
    if (input.value !== cleanValue) {
      input.value = cleanValue;

      // Si el formControlName es dinámico, encontramos el control de formulario
      if (this.formControlName) {
        const formControl = this.el.nativeElement.closest('form').querySelector(`[formControlName="${this.formControlName}"]`);
        if (formControl) {
          // Forzamos la actualización del control del formulario
          formControl.dispatchEvent(new Event('input'));
        }
      }
    }
  }

}